module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar aside-sm"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo  h-100",
    attrs: {
      "default-active": _vm.$route.path,
      "theme": "dark",
      "router": "",
      "unique-opened": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/index"
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("首页\n        ")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("教务管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/notify"
    }
  }, [_vm._v("通知管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/department"
    }
  }, [_vm._v("部门管理")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("blog")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/vueInit"
    }
  }, [_vm._v("vue-init")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/exportExcel"
    }
  }, [_vm._v("导出excel")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/excel"
    }
  }, [_vm._v("\n            导出Excel\n        ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/e404"
    }
  }, [_vm._v("\n            404\n        ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/echarts"
    }
  }, [_vm._v("\n            echarts\n        ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/user"
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 个人中心\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5850533c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Sidebar.vue
// module id = 600
// module chunks = 2